import React from 'react'
import styled from 'styled-components'
import { Profile, Help, Setting, Logout } from 'src/assets'
import { Link, useLocation } from 'react-router-dom'
import useUserData from 'src/hooks/useUserData'

const UserWrapper = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  overflow: hidden;
  .profileName {
    display: flex;
    flex-direction: column;
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.002em;
      color: ${({ theme }) => theme.colors.Cmk};
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 16px;
      letter-spacing: 0.4px;
      color: #505d67;
      margin-top: -10px;
    }
  }
  .flex {
    cursor: pointer;
  }
  .line {
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.cyanBlue};
    margin-top: -2px;
  }
  .profile {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: #24292e;
    margin-top: 12px;
  }
  .logout {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.4px;
    margin-top: -5px;
    color: #eb5757;
  }
`

const UserProfile = () => {
  let location = useLocation()
  const USER_DATA = useUserData()
  const profile_picture = USER_DATA.user.profile_picture
  return (
    <UserWrapper>
      <div className="flex">
        <div className="profileName">
          <h2>
            {USER_DATA.user.first_name} {USER_DATA.user.last_name}
          </h2>
          <p className="profileemail">{USER_DATA.user.email}</p>
        </div>
      </div>
      <div className="line"></div>
      <Link to="/profiles" state={{ backgroundLocation: location }}>
        <div className="flex">
          <p className="profile">View profile</p>
        </div>
      </Link>
      <Link to="/logout" state={{ backgroundLocation: location }}>
        <div className="flex">
          <p className="logout">Log out</p>
        </div>
      </Link>
    </UserWrapper>
  )
}

export { UserProfile }
